import moment from "moment";
export const rotate = { asc: "desc", desc: "", "": "asc" };
export const compare = (v1, v2) => {
    if (v1 instanceof Date) {
        return moment(v1).diff(v2);
    }
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
};
